export enum ButtonText {
    Save = "Save",
    Cancel = "Cancel",
    Close ="Close",
    AddNotification = "Add Notification"
}
